import { render, staticRenderFns } from "./FooterSocial.vue?vue&type=template&id=2df14953&scoped=true&"
import script from "./FooterSocial.vue?vue&type=script&lang=js&"
export * from "./FooterSocial.vue?vue&type=script&lang=js&"
import style0 from "./FooterSocial.vue?vue&type=style&index=0&id=2df14953&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df14953",
  null
  
)

export default component.exports